<template>
  <div
    class="galleryCard"
    :style="styleGaleryCard"
  >
    <div
      v-if="isActive"
      @click="activate"
    >
      <BgImage
        class="galleryImage"
        :path="item.images[0].path"
        :hotspot="item.images[0].hotspot"
      />
      <div
        class="clickPulse"
        v-if="!clicked"
      ></div>
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BgImage from '../BgImage.vue';

export default {
  name: 'galleryCard',
  components: {
    BgImage,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      clicked: false,
    };
  },
  computed: {
    ...mapGetters(['currentExhibit', 'currentPlayerGallery', 'currentGalleryItem', 'playerAudioActive']),
    isActive() {
      return !(!this.currentPlayerGallery);
    },
    hasActiveItem() {
      return this.isActive && !(!this.currentGalleryItem);
    },
    styleGaleryCard() {
      return {
        backgroundImage: `url(${this.getTinyPath()})`,
      };
    },
  },
  methods: {
    ...mapActions(['setPlayerGalleryItem', 'setPlayerAudio', 'setPlayerDescription', 'setPlayerAudioActive']),
    activate() {
      if (this.hasActiveItem) {
        this.setPlayerAudioActive(false);
        this.setPlayerGalleryItem(null);
        // this.$router.push({ name: 'Exhibit', params: { exhibitId: this.currentExhibit.id } });
      } else {
        this.clicked = true;
        this.setPlayerGalleryItem(this.item);
        // this.$router.push({ name: 'ExhibitItem', params: { itemId: this.item.id } });
        const description = `${this.item.name}, ${this.item.scientific} ${this.item.sex === 'weiblich' ? '\u2640' : '\u2642'}
        ${this.item.species}
        ${this.item.characteristics}
        ${this.item.habitat}`;

        this.setPlayerAudio(this.item.audio);
        this.setPlayerDescription(description);
        this.setPlayerAudioActive(true);

        if (process.env.VUE_APP_DEBUG === 'on') console.log('  from GalleryCard activate');
      }
    },
    getTinyPath() {
      const path = this.item.images[0].path.split('/');
      const file = path[path.length - 1].split('.');
      return `./galleries/tinder/img/tiny/${file[0]}-min.${file[1]}`;
    },
  },
};
</script>

<style lang="scss">
.galleryCard{
  position: relative;
  width: 100%;
  height: 76vh;
  height: calc(var(--vh, 1vh) * 76);
  overflow: hidden;
  box-sizing: border-box;
  /* padding: 0 10vw; */
  background-size: cover;
  background-position: center;

  height: 86vh;
  height: calc(var(--vh, 1vh) * 86);

  .galleryImage {
    width: 100%;
    min-height: 86vh;
    min-height: calc(var(--vh, 1vh) * 86);
    background-position: center;
    background-size: cover;
    /* background-size: calc(10vh + 68vw);
    padding: 0 10vw; */
    box-sizing: border-box;
  }

  h3 {
    font-size: 1.1em;
    margin: 0;
    padding: 0;
    padding-top: 35px;
  }

  .galleryCardContent {
    height: 86vh;
    height: calc(var(--vh, 1vh) * 86);
    text-align: left;
    padding: 30px 0;
    overflow-y: scroll;
    box-sizing: border-box;
    transition: height .3s ease;
  }

  .clickPulse {
    pointer-events: none;
    position: fixed;
    bottom: 40vh;
    left: calc(50vw - 20px);
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: #ffffff44;
    transform: scale(1);
    animation: pulse 1s infinite ease-out;
  }
  @keyframes pulse {
    0% {transform: scale(0);}
    10% {transform: scale(1);}
    100% {transform: scale(0);}
  }
}
@media only screen and (orientation : portrait)
 and (min-aspect-ratio: 4/9)
 and (max-height : 700px) {
  .galleryCard{
    .galleryImage {
    }
    .galleryCardContent {
    }
  }
}
@media only screen and (min-aspect-ratio: 7/10) { /* Landscape Including Edge Case */
  .galleryCard{
    .galleryImage {
      background-size: 100%;
    }
  }
}
@media only screen and (orientation : landscape) {
  .galleryCard {
    height: 86vh;
    height: calc(var(--vh, 1vh) * 86);
    padding: 0;

    .galleryImage {
      width: 62vw;
    }
    .galleryCardContent {
      width: 62vw;
    }
    .clickPulse {
      left: calc(31vw - 20px);
    }
  }
  @media only screen and (min-aspect-ratio: 3/2) { // and (max-width : 900px)
    .galleryCard {
      .galleryImage {
        width: 38vw;
      }
      .galleryCardContent {
        width: 38vw;
      }
      .clickPulse {
        left: calc(19vw - 20px);
      }
    }
  }
}
</style>
